<div>
    <canvas id="myDashboardChart"></canvas>
  </div>
